<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-row>
      <b-col md="6" class="my-1">
        <b-navbar-nav>
          <b-button @click="goBack" size="sm" variant="light">
            <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
          </b-button>
        </b-navbar-nav>
        <h5 class="mt-1 mr-2">
          {{ $route.name }}
        </h5>
      </b-col>
      <b-col md="2">
        <h5>
          <small v-if="isLoading == false"
            >{{ getPrerequisiteItemList.length }} Entries</small
          >
        </h5>
      </b-col>
      <b-col md="4">
        <b-button
          class="pull-right ml-1 mt-1"
          :variant="
            Filter.PrerequisiteFilter ||
            Filter.commonFilter ||
            Filter.clientFilter ||
            Filter.createdByFilter ||
            Filter.statusFilter ||
            Filter.dateRange.startDate ||
            Filter.dateRange.endDate
              ? 'outline-danger'
              : 'outline-primary'
          "
          :class="' ml-4' + visible ? null : 'collapsed'"
          :aria-expanded="visible ? 'true' : 'false'"
          aria-controls="collapse-4"
          @click="visible = !visible"
          style="font-size: 0.675rem"
          >{{
            Filter.PrerequisiteFilter ||
            Filter.commonFilter ||
            Filter.clientFilter ||
            Filter.createdByFilter ||
            Filter.statusFilter ||
            Filter.dateRange.startDate ||
            Filter.dateRange.endDate
              ? "Filter ON"
              : "Filter OFF"
          }}</b-button
        >
        <b-button
          class="pull-right ml-1 mt-1"
          v-if="getPrerequisiteItemList.length > 0"
          :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
          @click="getReports('getPrerequisiteList', 'Export As Excel')"
          size="sm"
          variant="warning"
          style="font-size: 0.675rem"
        >
          {{ ExcelBtnName }}
          <b-spinner
            v-if="ExcelBtnName != 'Export As Excel'"
            small
            label="Small Spinner"
          ></b-spinner
        ></b-button>
        <b-button
          size="sm"
          class="pull-right mt-1"
          @click="addPrerequisite('add', '')"
          variant="primary"
          >Add</b-button
        >
      </b-col>

      <b-col cols="12">
        <div>
          <b-pagination
            limit="25"
            align="center"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total-rows="totalData"
            @change="onPageChange($event)"
          ></b-pagination>
        </div>
      </b-col>
    </b-row>
    <div v-if="visible">
      <b-card>
        <b-collapse v-model="visible" id="collapse-2">
          <b-row>
            <b-col md="3">
              <label>Status</label>

              <model-list-select
                :list="StatusList"
                v-model="Filter.statusFilter"
                option-value="DVal"
                option-text="DText"
                placeholder="Select"
                @input="getPrerequisiteList('Normal', '0', '0', '1', '1')"
              ></model-list-select>
            </b-col>
            <b-col md="3">
              <label>Date</label>
              <date-range-picker
                :always-show-calendars="showCal"
                v-model="Filter.dateRange"
                :startDate="startDate"
                :endDate="endDate"
                :locale-data="locale"
                :disabled="Filter.DFlag ? true : false"
                @update="getPrerequisiteList('Normal', '0', '0', '1', '1')"
              ></date-range-picker>
            </b-col>

            <b-col md="3">
              <label>Client</label>
              <model-list-select
                :list="$store.getters['common/getAllClientList']"
                v-model="Filter.clientFilter"
                option-value="clientId"
                option-text="clientName"
                placeholder="Select Shipper Name"
                @input="getPrerequisiteList('Normal', '0', '0', '1', '1')"
              ></model-list-select>
            </b-col>

            <b-col md="3">
              <label>Prerequisite No Filter</label>
              <b-form-input
                type="text"
                :formatter="capitalizeAll"
                placeholder="Search Prerequisite No Filter"
                id="PrerequisiteFilter"
                name="PrerequisiteFilter"
                autocomplete="off"
                v-model="Filter.PrerequisiteFilter"
                @input="getPrerequisiteList('Normal', '0', '0', '1', '1')"
              ></b-form-input>
            </b-col>
            <b-col md="3">
              <label>Common Filter</label>
              <b-form-input
                type="text"
                :formatter="capitalizeAll"
                placeholder="Search Common Filter"
                id="commonFilter"
                name="commonFilter"
                autocomplete="off"
                v-model="Filter.commonFilter"
                @input="getPrerequisiteList('Normal', '0', '0', '1', '1')"
              ></b-form-input>
            </b-col>
            <b-col md="3">
              <label>
                <b> Created User </b>
              </label>
              <model-list-select
                :list="$store.getters['common/getAllUserList']"
                id="createdByFilter"
                @input="getPrerequisiteList('Normal', '0', '0', '1', '1')"
                v-model="Filter.createdByFilter"
                option-value="userId"
                option-text="employeeName"
                placeholder="Select Created User"
              ></model-list-select>
            </b-col>
            <b-col md="12" class="mt-2">
              <b-button
                size="sm"
                style="margin-left: auto"
                class="ml-1 pull-right"
                @click="clearFilter"
                variant="outline-danger"
                >Reset</b-button
              >
            </b-col>
          </b-row>
        </b-collapse>
      </b-card>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive tableMain gutr">
          <b-table
            show-empty
            stacked="md"
            responsive
            :items="getPrerequisiteItemList"
            :fields="PrerequisiteFields"
            primary-key="id_email_section"
            class="position-relative"
            :per-page="pagination.perPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
          >
            <template slot="SN" slot-scope="row0">
              <span>{{
                row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
              }}</span>
            </template>

            <template slot="preq_no" slot-scope="row1">
              <span>Prerequisite No : {{ row1.item.preq_no }}</span
              ><br />
              <span>Cancelled Client : {{ row1.item.cancelShipperName }}</span
              ><br />
              <span>Used Client : {{ row1.item.UsedShipperName }}</span>
            </template>
            <template slot="JobNo" slot-scope="row1">
              <span 
              style="color:blue;font-size:14px;margin-right:5%"
              @click="row1.item.JobId? goToConsolidation(row1.item.JobId):''"
                class="showMoreData">Job No : {{ row1.item.JobNo }}</span
              ><br />
              <span>Job Date : {{ row1.item.JobDate }}</span>

              <h6>
                <b-badge
                  :variant="row1.item.preq_is_converted === '1' ? 'success' : 'danger'"
                  >{{
                    row1.item.preq_is_converted === "1" ? "Converted" : "Pending"
                  }}</b-badge
                >
              </h6>
            </template>

            <template slot="clientName" slot-scope="row3">
              <div v-if="row3.item.clientName">
                <span
                  v-for="(item1, index) in row3.item.clientName.split(',')"
                  :key="index"
                  ><h6>
                    <b-badge variant="light"
                      >{{ item1 == "" ? "-------" : item1 }}
                    </b-badge>
                  </h6></span
                >
              </div>
            </template>

            <template slot="raisedBy" slot-scope="row4">
              <span v-if="row4.item.raisedBy"
                >Raised By : {{ row4.item.raisedBy }}<br
              /></span>
              <span v-if="row4.item.create_date"
                >Created Date : {{ row4.item.create_date }}<br
              /></span>
              <span v-if="row4.item.updatedBy"
                >Updated By : {{ row4.item.updatedBy }}<br
              /></span>
              <span v-if="row4.item.update_date"
                >Updated Date : {{ row4.item.update_date }}<br
              /></span>

              <b-button
                size="sm"
                class="pull-left"
                @click="addPrerequisite('edit', row4.item)"
                variant="primary"
                >{{ row4.item.preq_is_converted === "1" ? "View" : "Edit" }}</b-button
              >
            </template>
          </b-table>
        </div>
        <div>
          <b-pagination
            limit="25"
            align="center"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total-rows="totalData"
            @change="onPageChange($event)"
          ></b-pagination>
        </div>
      </div>
    </div>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import AccountService from "../../services/AccountService.js";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
export default {
  // Component logic for Tab 1
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);

    this.$store.dispatch(
      "common/setAllClientList",
      JSON.stringify({
        itemCode: "ClientList",
      })
    );

    if (globalPermissionStatus("Pridel Document")) {
      this.$store.dispatch("setCurrentRoute", "/console_booking/ContarctList");
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.getPrerequisiteList("Normal", "0", "0", "1", "1");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  mounted() {},
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},
  data() {
    return {
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      visible: false,
      getPrerequisiteItemList: [],
      totalData: 0,
      PrerequisiteFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },

        {
          key: "preq_no",
          mainkey: "preq_no",
          label: "Prerequisite No",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "JobNo",
          mainkey: "JobNo",
          label: "Job No",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        // {
        //   key: "JobDate",
        //   mainkey: "JobDate",
        //   label: "Job Date",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        // },
        {
          key: "clientName",
          mainkey: "clientName",
          label: "Shipper",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "raisedBy",
          mainkey: "raisedBy",
          label: "Action",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
      ],
      pagination: {
        currentPage: 1,
        perPage: 25,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,

      StatusList: [
        {
          DVal: "0",
          DText: "In-Active",
        },
        {
          DVal: "1",
          DText: "Active",
        },
        {
          DVal: "2",
          DText: "All",
        },
      ],
      Filter: {
        PrerequisiteFilter: "",
        commonFilter: "",
        clientFilter: "",
        createdByFilter: "",
        statusFilter: "2",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
    };
  },

  components: {
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,

    MultiSelect,
    Multiselect,
  },
  computed: {},
  watch: {},
  methods: {
    goToConsolidation(FCLCONID) {
      this.$sessionsStorage.set("editffFclConsoExportId", FCLCONID);
      this.$router.push({
        path: "/ffExportCon/ffExportFclConsolidation",
      });
    },
    addPrerequisite(type, item) {
      if (type == "edit") {
        this.$sessionsStorage.set("editffFclConsoPreqId", "");
        this.$sessionsStorage.set("editffFclConsoPreqId", item.preq_id);
      } else {
        this.$sessionsStorage.set("editffFclConsoPreqId", "");
      }
      this.$router.push({
        path: "/ffExportCon/ffExportFclConPreq",
      });
    },

    clearFilter() {
      this.Filter = {
        PrerequisiteFilter: "",
        commonFilter: "",
        clientFilter: "",
        createdByFilter: "",
        statusFilter: "2",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
    },
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.Filter.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
    },

    getPrerequisiteList(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      this.getPrerequisiteItemList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        itemCode: "getPrerequisiteList",
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.pagination.perPage,
        Filter: this.Filter,
      };

      AccountService.getAllPrerequisiteList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log();
          if (status == 200 && data) {
            if (type == "Excell") {
              if (data.getPrerequisiteList.length > 0) {
                this.totalData = data.totalRows;
                this.getPrerequisiteItemList = data.getPrerequisiteList;
              }
              this.ExcelBtnName = "Export As Excel";
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.getPrerequisiteList.length > 0) {
                this.totalData = data.totalRows;
                this.getPrerequisiteItemList = data.getPrerequisiteList;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getPrerequisiteList Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    clearTimeout() {},
    goBack() {
      window.history.go(-1);
    },
    filterClear() {
      this.Filter = {
        pendingClient: "",
        clientNameFilter: "",
        clientIdFilter: "",
        branchFilter: "",
        transportTypeFilter: "Export",
        shipmentTypeFilter: "",
        jobTypeFilter: "",
      };
      this.getPrerequisiteList("Normal", "0", "0", "1", "1");
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getPrerequisiteList("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getPrerequisiteList("Excell", "0", "0", "1", "1");
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getPrerequisiteList("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getPrerequisiteList("Normal", "0", CURRENT, "2", event);
    },
  },
};
</script>



// WEBPACK FOOTER //
// PrerequisiteList.vue?6dea175c